import * as React from 'react';
import { BaseProps, Classes, InverseBgProvider } from '../index';
import classNames from 'classnames';
export type TagHeaderGroupContainer = Omit<BaseProps, 'title'> & {
  title?: React.ReactNode | string;
  banner?: React.ReactNode;
};
export const TagHeaderGroupContainer: React.FC<TagHeaderGroupContainer> = ({
  className,
  style,
  title,
  children,
  banner,
}) => {
  return (
    <div
      className={classNames(className, Classes.TAG_HEADER_GROUP_CONTAINER)}
      style={style}
    >
      <InverseBgProvider inverse>
        <div className={Classes.GROUP_CONTAINER_HEADER_TITLE}>{title}</div>
      </InverseBgProvider>
      {banner}
      <div className={Classes.GROUP_CONTAINER_BODY}>{children}</div>
    </div>
  );
};
